import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// Ensure ALL axios calls carry the auth cookie (customer_token / session_token).
// Without this, some in-app axios calls silently drop credentials which can
// make the session look broken after a refresh in strict mobile browsers.
axios.defaults.withCredentials = true;

// Fallback for browsers / iframes where 3rd-party cookies are blocked
// (Chrome "Block third-party cookies", Safari ITP, iOS in-app browsers).
// We attach either the customer or admin token as `Authorization: Bearer …`
// on every request — the backend accepts either cookie OR this header.
axios.interceptors.request.use((config) => {
  try {
    // Admin token wins for /admin/* and /auth/* endpoints, customer token elsewhere.
    const url = (config.url || '').toLowerCase();
    const isAdminApi = url.includes('/admin/') || url.includes('/auth/');
    const adminToken = localStorage.getItem('balmart_admin_token');
    const customerToken = localStorage.getItem('balmart_customer_token');
    const token = isAdminApi ? (adminToken || customerToken) : (customerToken || adminToken);
    if (token) {
      config.headers = config.headers || {};
      if (!config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
  } catch { /* localStorage unavailable (private mode) — skip silently */ }
  return config;
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
